var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"title":"pricing"}}),_c('div',{staticClass:"pricing-wrapper"},_vm._l((_vm.pricingCard),function(data,index){return _c('pricing-card',{key:index,attrs:{"row":data}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }